import styled from 'styled-components';
// heading
export const Heading1 = styled.h1`
	font-family: 'Futura PT Demi', sans-serif;
	font-size: 4rem;
	line-height: 5rem;
	font-weight: 600;
	@media screen and (max-width: 767px) {
		font-size: 2.8rem;
		line-height: 3.5rem;
	}
`;
export const Heading2 = styled.h2`
	font-family: 'Futura PT Demi', serif;
	font-size: 3.2rem;
	line-height: 4rem;
	font-weight: 600;
	@media screen and (max-width: 767px) {
		font-size: 2.2rem;
		line-height: 3rem;
	}
`;
export const Heading3 = styled.h3`
	font-family: 'Futura PT Demi', serif;
	font-size: 2.4rem;
	line-height: 3rem;
	font-weight: 600;
`;
export const Heading21 = styled.h3`
	font-family: 'Futura PT Demi', serif;
	font-size: 2.1rem;
	line-height: 3rem;
	font-weight: 600;
`;
export const Heading4 = styled.h4`
	font-family: 'Verdana', sans-serif;
	font-weight: bold;
	font-size: 1.6rem;
	line-height: 2.4rem;
`;
export const Heading5 = styled.h5`
	font-family: 'Verdana', sans-serif;
	font-weight: bold;
	font-size: 1.4rem;
	line-height: 2rem;
`;

// text
export const Text1 = styled.p`
	font-family: 'Verdana', sans-serif;
	font-size: 2rem;
	line-height: 3.2rem;
`;
export const Text1Money = styled.p`
    font-family: 'Futura PT Demi', serif;
    font-size: 2rem;
    line-height: 3rem;
    font-weight: 600;
`;

export const Text1Bold = styled(Text1)`
    font-weight: bold;
`;
export const Text2 = styled.p`
	font-family: 'Verdana', sans-serif;
	font-size: 1.6rem;
	line-height: 2.4rem;
`;
export const Text3 = styled.p`
	font-family: 'Verdana', sans-serif;
	font-size: 1.4rem;
	line-height: 2.2rem;
`;
export const Text4 = styled.p`
	font-family: 'Verdana', sans-serif;
	font-size: 1.2rem;
	line-height: 2rem;
	white-space: pre-line;
	margin: 0;
`;
export const TextButton = styled.span`
	font-family: 'Verdana', sans-serif;
	font-size: 1.4rem;
	line-height: 2rem;
`;
export const TextButton12 = styled.span`
	font-family: 'Verdana', sans-serif;
	font-size: 1.2rem;
	line-height: 2rem;
`;
export const TextButton16 = styled.span`
	font-family: 'Verdana', sans-serif;
	font-size: 1.6rem;
	line-height: 2rem;
`;

export const TextSubtitle = styled.p`
	font-family: 'Verdana', sans-serif;
	font-weight: bold;
	font-size: 1.1rem;
	line-height: 1.5rem;
`;
export const TextCaption = styled.p`
	font-family: 'Verdana', sans-serif;
	font-size: 1rem;
	line-height: 1.5rem;
	margin: 0;
`;

// colors
export const black = '#000000';
export const darkGrey = '#464646';
export const black40 = 'rgba(0, 0, 0, 0.4)';
export const black10 = 'rgba(0, 0, 0, 0.1)';
export const black3 = 'rgba(0, 0, 0, 0.03)';
export const white = '#ffffff';
export const grey = '#cccccc';
export const halfDarkGrey = '#999999';
export const lightBlue = '#41B6E6';
export const lightBlueHover = '#299DCD';
export const lightBlueClick = '#037BAC';
export const blue = '#003D81';
export const blue10 = 'rgba(0, 61, 129, 0.1)';
export const blue7 = 'rgba(0,61,129,0.07)';
export const red = '#D23630';
export const red20 = 'rgba(210, 54, 48, 0.2)';
export const yellow = '#F3AB46';

export const greyTableHeader = '#E6E6E6';
export const greyTableRow = '#F7F9FB';

export const ANIMATION_SEC: number = 0.3;
export const Z_INDEX_LITTLE_BIT: number = 2;
export const Z_INDEX_MODAL: number = 50;

export const DEFAULT_SHADOW: string = '0px 2px 20px rgba(0, 0, 0, 0.08)';

export const visuallyHidden = `
  position: absolute;

  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;

  border: 0;

  clip: rect(0 0 0 0);
`;
